import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  TextField,
  Button,
  Alert,
  Box,
  InputAdornment,
  IconButton
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../stores/useAuthStore';

interface FormValues {
  userName: string;
  password: string;
  companyId: string;
}

const validationSchema = Yup.object({
  userName: Yup.string().required('Kullanıcı Adı zorunlu'),
  password: Yup.string().required('Şifre zorunlu'),
});

function LoginForm() {
  const { login, error, isLoggedIn } = useAuthStore();
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const formik = useFormik<FormValues>({
    initialValues: {
      userName: '',
      password: '',
      companyId: '01',
    },
    validationSchema,
    onSubmit: async (values) => {
      await login(values);
    },
  });

  useEffect(() => {
    if (isLoggedIn && !error) {
      navigate('/home');
    }
  }, [isLoggedIn, error, navigate]);

  return (
    <Box
      component="form"
      onSubmit={formik.handleSubmit}
      sx={{
        width: '100%',
        maxWidth: 300,
        mx: 'auto',
        textAlign: 'left',
      }}
    >
      {error && <Alert severity="error">{error}</Alert>}
      {isLoggedIn && <Alert severity="success">Giriş başarılı!</Alert>}

      <TextField
        fullWidth
        margin="normal"
        id="userName"
        name="userName"
        label="Kullanıcı Adı"
        value={formik.values.userName}
        onChange={formik.handleChange}
        error={formik.touched.userName && Boolean(formik.errors.userName)}
        helperText={formik.touched.userName && formik.errors.userName}
      />

      <TextField
        fullWidth
        margin="normal"
        id="password"
        name="password"
        label="Şifre"
        type={showPassword ? 'text' : 'password'}
        value={formik.values.password}
        onChange={formik.handleChange}
        error={formik.touched.password && Boolean(formik.errors.password)}
        helperText={formik.touched.password && formik.errors.password}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleTogglePassword} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <Button variant="contained" type="submit" sx={{ mt: 2, mb:3 }} fullWidth>
        Giriş Yap
      </Button>
    </Box>
  );
}

export default LoginForm;
